export const buildDailyMealPlanPayload = (date, nightOnly) => ({
  date,
  night_only: Boolean(nightOnly),
});


export const applyNightOnlyHistoryUpdate = (history, date, nightOnly) => (
  history.map(day => (
    day.date === date
      ? { ...day, night_only: Boolean(nightOnly) }
      : day
  ))
);
